import { useContext, useEffect, useState } from "react";
import { ThemeData } from "../../../contexts/themeContext/themeContext";
import { Text } from "../../../contexts/textContext/textContext";

export default function CounterItem(props) {

    const theme = useContext(ThemeData);
    const text = useContext(Text);
    const [counter, setCounter] = useState(0);

    // function for first counter
    function characterCounter() {
        return text.length;
    }

    // function for second counter
    function wordCounter() {
        let wordCounts = 0;
        if (text) {
            wordCounts = text.trim().split(' ').length;
        }
        // اگر متن دارای کاراکتر خط جدید بود به ازایه هرکدام یک کلمه اضافه شود
        text.split('').map((letter) => letter === '\n' && wordCounts++);
        return wordCounts;
    }

    // function for third counter
    function sentenceCounter() {
        let sentenceCounts = 0;
        if (text) {
            sentenceCounts = text.trim().split('.').length - 1;
        }
        // اگر متن دارای کاراکتر خط جدید بود به ازایه هرکدام یک جمله اضافه شود
        text.split('').map((letter) => letter === '\n' && sentenceCounts++);
        return sentenceCounts;
    }

    useEffect(() => {
        switch (props.id) {
            case 0:
                setCounter(characterCounter());
                break;
            case 1:
                setCounter(wordCounter());
                break;
            case 2:
                setCounter(sentenceCounter());
                break;
            default:
                break;
        }
    }, [text]);

    return (
        <div className={`position-relative overflow-hidden p-3 text-start rounded rounded-4 h-100 counter${props.id}`}>
            <div className="d-flex flex-column justify-content-between h-100">
                <h4 className="counterTitle w-50 position-relative">
                    {props.title}
                </h4>
                <span>
                    {counter}
                </span>
            </div>
            {/* this div is for background only */}
            <div className={`text-end top-0 end-0 h-100 ${theme === 'dark' && `counterItem${props.id}`}`}></div>
        </div >
    );
}